import brandAmazon from "@/public/images/incentive_brands/brand_amazon.png"
import brandApple from "@/public/images/incentive_brands/brand_apple.png"
import brandAupay from "@/public/images/incentive_brands/brand_aupay.png"
import brandDpoint from "@/public/images/incentive_brands/brand_dpoint.png"
import brandGoogleplay from "@/public/images/incentive_brands/brand_googleplay.png"
import brandNanaco from "@/public/images/incentive_brands/brand_nanaco.png"
import brandPaypay from "@/public/images/incentive_brands/brand_paypay.png"
import brandQuopay from "@/public/images/incentive_brands/brand_quopay.png"
import brandVisa from "@/public/images/incentive_brands/brand_visa.png"

export type GiftBrandIcon = { src: string; alt: string }

// design Frame gft4N "brands" の順序に合わせたブランドアイコン
export const GIFT_BRAND_ICONS: readonly GiftBrandIcon[] = [
	{ src: brandPaypay, alt: "PayPay ポイント" },
	{ src: brandAmazon, alt: "Amazon" },
	{ src: brandGoogleplay, alt: "Google Play" },
	{ src: brandVisa, alt: "Visa" },
	{ src: brandApple, alt: "Apple" },
	{ src: brandDpoint, alt: "d POINT" },
	{ src: brandAupay, alt: "au PAY" },
	{ src: brandNanaco, alt: "nanaco" },
	{ src: brandQuopay, alt: "QUO カード Pay" },
]
